import React, { useEffect, useState } from 'react';
import './monitor.css';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import MonitorHeader from "../../components/PagesHeaders/MonitorHeader/MonitorHeader";
import { closeWorkoutSagaAction, currentVisitorsSagaAction } from "../../redux/sagaActions";
import MonitorItem from "../../components/MonitorItem/MonitorItem";
import KeyForm from "../../components/KeyForm/KeyForm";
import { keyNumberAction } from "../../redux/rootReducer";
import MonitorFilters from "../../components/MonitorFilters/MonitorFilters";

const Monitor = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const currentVisitors = useSelector(state => state.currentVisitors);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const search = useSelector(state => state.search);
    const monitor_view = useSelector(state => state.monitor_view);

    const [filteredVisitors, setFilteredVisitors] = useState(currentVisitors);

    // Фильтрация посетителей по поиску
    useEffect(() => {
        // Если нет посетителей, возвращаем пустой массив
        if (!currentVisitors.length) {
            setFilteredVisitors([]);
            return;
        }

        if (!search.length) setFilteredVisitors(currentVisitors);

        let lowerSearch = search?.toLowerCase();

        setFilteredVisitors(currentVisitors.filter(elem => {
            if (
                (elem.user &&
                elem.user?.name?.toLowerCase()?.indexOf(lowerSearch) + 1 ||
                elem.user?.phone?.indexOf(search) + 1 ||
                elem.user?.phone_formatted?.indexOf(search) + 1) ||
                elem.type?.name?.indexOf(lowerSearch) + 1
            ) return elem;
        }));
    }, [search, currentVisitors]);

    useEffect(() => {
        if (!currentEstablishment) return;
        // Получение посетителей, находящихся в зале в текущий момент
        dispatch(currentVisitorsSagaAction({ establishment: currentEstablishment }));
    }, [currentEstablishment]);

    return (
        <>
            <Header component={ <MonitorHeader /> } />
            <div className="page">
                <KeyForm/>
                <div className="page__content">
                    {
                        monitor_view === 'tile'
                            ?
                            <>
                                <div className="table__header">
                                    <div className="table__caption">{ `Активные тренировки (${ filteredVisitors.length })` }</div>
                                </div>
                                <div className="monitor__items">
                                    {
                                        filteredVisitors.map(elem => {
                                            return <MonitorItem key={ elem.workout_id } data={ elem } />;
                                        })
                                    }
                                </div>
                            </>
                            : monitor_view === 'table'
                            ?
                            <div className="table__wrapper">
                                <div className="table__header">
                                    <MonitorFilters/>
                                    <div className="table__caption">{ `Активные тренировки (${ filteredVisitors.length })` }</div>
                                </div>
                                <div className="table">
                                    <div className="table__row table__row--header monitor__row">
                                        <div className="table__cell table__cell--left">Имя</div>
                                        <div className="table__cell">Телефон</div>
                                        <div className="table__cell">Тип тренировки</div>
                                        <div className="table__cell">Начало</div>
                                        <div className="table__cell">Ключ</div>
                                        <div className="table__cell">Разовое</div>
                                        <div className="table__cell table__cell--left">Примечание</div>
                                        <div className="table__cell" />
                                    </div>
                                    {
                                        filteredVisitors.map(elem => {
                                            return (
                                                <div className={ `table__row monitor__row ${ elem.user.id ? 'table__row--hover' : '' }` } key={ elem.workout_id }
                                                     onClick={ () => {
                                                         // Если нет id пользователя (разовое занятие), выходим из функции
                                                         if (!elem.user.id) return false;

                                                         // Переходим на страницу с посетителями
                                                         history.push('/fitness/users/' + elem.user?.id);
                                                     } }
                                                >
                                                    <div className={ `table__cell table__cell--left ${ !elem.user.id ? 'table__cell--inactive' : '' }` }>{ elem.user.name }</div>
                                                    <div className="table__cell">{ elem.user.phone_formatted }</div>
                                                    <div className="table__cell">{ elem.type?.name }</div>
                                                    <div className="table__cell">{ elem.start }</div>
                                                    <div className={ `table__cell monitor__row-key ${ elem.key_number ? 'monitor__row-key--active' : '' }` }
                                                         onClick={ event => {
                                                             event.preventDefault();
                                                             event.stopPropagation();
                                                             dispatch(keyNumberAction({
                                                                 open: true,
                                                                 number: elem.key_number,
                                                                 workout_id: elem.workout_id,
                                                                 type: 'save'
                                                             }));
                                                         } }
                                                    >{ elem.key_number }</div>
                                                    <div className="table__cell">
                                                        {
                                                            elem.one_time ? <div style={{ color: 'var(--main-color)' }}>&#10004;</div> : false
                                                        }
                                                    </div>
                                                    <div className="table__cell table__cell--left">{ elem.note }</div>
                                                    <div className="table__cell monitor__row-close" onClick={ event => {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        dispatch(closeWorkoutSagaAction({
                                                            workout_id: elem.workout_id
                                                        }));
                                                    } }>Завершить</div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                            : false

                    }
                </div>
            </div>
        </>
    );
};

export default Monitor;